<template>
 <AdminPanelEpicentrkShoppingPacket />
</template>

<script>
import AdminPanelEpicentrkShoppingPacket  from '../components/AdminPanelEpicentrkShoppingPacket.vue'
export default {
    data: () => ({}),
    components: {
        AdminPanelEpicentrkShoppingPacket
    },
    methods: {},
    mounted() {}
}
</script>
